var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 101,
    viewBox: "0 0 130 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 47
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M62.3699 100C88.86 100 110.336 78.5244 110.336 51.9396C110.336 25.3549 88.7654 3.87891 62.3699 3.87891C35.8799 3.87891 14.404 25.3549 14.404 51.9396C14.404 78.5244 35.8799 100 62.3699 100Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 1.89215,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M107.215 20.4356C109.357 20.4356 111.093 18.6989 111.093 16.5567C111.093 14.4144 109.357 12.6777 107.215 12.6777C105.072 12.6777 103.336 14.4144 103.336 16.5567C103.336 18.6989 105.072 20.4356 107.215 20.4356Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M112.891 5.29803C114.354 5.29803 115.54 4.11203 115.54 2.64902C115.54 1.186 114.354 0 112.891 0C111.428 0 110.242 1.186 110.242 2.64902C110.242 4.11203 111.428 5.29803 112.891 5.29803Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.9583 20.341C18.4213 20.341 19.6073 19.155 19.6073 17.692C19.6073 16.229 18.4213 15.043 16.9583 15.043C15.4953 15.043 14.3093 16.229 14.3093 17.692C14.3093 19.155 15.4953 20.341 16.9583 20.341Z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.81186 77.6048C8.52887 77.6048 10.7314 75.4023 10.7314 72.6852C10.7314 69.9682 8.52887 67.7656 5.81186 67.7656C3.09485 67.7656 0.892273 69.9682 0.892273 72.6852C0.892273 75.4023 3.09485 77.6048 5.81186 77.6048Z",
    fill: "#F1F3F9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M129.106 88.2836C129.037 90.6191 126.977 92.405 124.641 92.405H94.4172C93.3181 92.405 92.4251 93.2293 92.3564 94.2597C92.2878 95.4274 93.1807 96.3204 94.3485 96.3204H102.042C102.523 96.3204 102.935 96.7326 102.935 97.2134C102.935 97.6942 102.523 98.1064 102.042 98.1064H56.706C54.3705 98.1064 52.3785 96.3204 52.2411 93.9849C52.1724 91.5807 54.0958 89.5887 56.4999 89.5887H63.1629C64.1246 89.4513 64.9489 88.627 64.9489 87.5967C64.9489 86.4976 64.0559 85.6046 62.9568 85.6046H42.487C39.0525 85.6046 36.0988 83.0631 35.8927 79.6285C35.618 75.9192 38.5717 72.8281 42.281 72.8281H102.591C106.095 72.8281 108.98 75.7131 108.98 79.2164C108.98 80.7276 108.43 82.1014 107.606 83.2005C108.018 83.4065 108.361 83.6126 108.705 83.8874H125.053C127.251 83.9561 129.175 85.8794 129.106 88.2836Z",
    fill: "#9FA8BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M84.1469 28.6758L66.0812 32.179L35.7887 38.0864L22.4627 40.6967C20.0585 41.1775 18.4099 43.3756 18.616 45.8485L21.2262 75.0421C21.4323 77.4463 23.493 79.3697 25.8972 79.3697L88.7492 80.1253L84.1469 28.6758Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 1.89215,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M91.6336 30.7364L95.8238 76.828C95.8238 77.1715 95.6177 77.5149 95.2742 77.5836L90.2598 78.6827L85.7949 29.9121L90.9467 30.0495C91.2902 30.0495 91.5649 30.3929 91.6336 30.7364Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 1.89215,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M80.1633 26.89L85.2464 82.6671C85.3151 83.0792 85.7272 83.354 86.0707 83.1479L91.0164 81.2246C91.6346 80.9498 92.0468 80.2629 91.9781 79.576L87.3758 28.5386C87.3071 27.8517 86.8263 27.3022 86.1394 27.0961L80.9189 26.2031C80.5068 26.1344 80.1633 26.4779 80.1633 26.89Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 1.89215,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M66.7687 32.1104L36.4761 38.0178C36.1326 39.6664 35.9952 41.3149 36.2013 43.0322C37.0256 52.3055 45.1998 59.1059 54.4043 58.2816C63.6089 57.4573 70.4093 49.2831 69.585 40.0785C69.3102 37.1248 68.3485 34.4458 66.7687 32.1104Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 1.89215,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.2e242d2de6d53f5d9b130455f100d556.svg";
export { ForwardRef as ReactComponent };